export default __webpack_public_path__ + "static/media/IMG_20181026_172834737.d401d7e0.jpg";